var exports = {
  "i": "IssueDetailContainer__O-NGqq",
};

module.exports = exports;
